import { useMemo } from "react";
import { useAppContext } from "../context/appContext";
import { useAuthContext } from "../context/authContext";
import { ApiHeaders, buildApiHeaders } from "../http/apiHeaders";

/**
 * The headers for our API (see buildApiHeaders), for requests that can't go through useApi: plain
 * fetches in module-level caches, or XHR uploads that report progress. The same object while the
 * login token and the app scope stay the same, so it's safe as an effect dependency.
 */
export const useApiHeaders = (): ApiHeaders => {
  const { jwtToken } = useAuthContext();
  const { scope } = useAppContext();
  return useMemo(() => buildApiHeaders(jwtToken, scope), [jwtToken, scope]);
};
